import { Box, CircularProgress, Container, makeStyles, Paper, Theme } from "@material-ui/core";
import { FunctionComponent, lazy, Suspense } from "react";
import { useTranslation } from 'react-i18next';

const PartnerPortal = lazy(() => import(/* webpackChunkName: "partner-portal-module" */ "../PartnerPortal"));
const Warehouse = lazy(() => import(/* webpackChunkName: "warehouse-module" */ "../Warehouse"));

interface HomeProps
{
  isLoggedIn: boolean;
  hasWarehousePermission: boolean;
  loading: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  progress: {
    padding: theme.spacing(4),
    marginLeft: "auto",
    marginRight: "auto",
    width: 40 + 2 * theme.spacing(4),
    height: 40 + 2 * theme.spacing(4),
  },
}));

const Component: FunctionComponent<HomeProps> = ({ isLoggedIn, hasWarehousePermission, loading }) =>
{
  const { t } = useTranslation();
  const classes = useStyles();

  if(loading) return <Box className={classes.progress}><CircularProgress color="secondary" /></Box>;

  if(hasWarehousePermission)
  {
    return (
      <Container maxWidth="xs">
        <Suspense fallback={<Box className={classes.progress}><CircularProgress color="secondary" /></Box>}>
          <Warehouse />
        </Suspense>
      </Container>
    );
  }

  if(isLoggedIn) return (
    <Suspense fallback={<Box className={classes.progress}><CircularProgress color="secondary" /></Box>}>
      <PartnerPortal />
    </Suspense>
  )

  return (
    <Paper elevation={3} style={{ padding: 20, margin: 20 }}>
      <h1>{t('home.title')}</h1>
      <p>{t('home.description')}</p>
    </Paper>
  );
};

export default Component;
